import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import {Button} from '../ui/button';
import {Upload} from 'lucide-react';

const FileUploadSection = ({files, handleFileChange, removeFile}) => {
  return (
    <Card className="glass-effect border-gray-700">
      <CardHeader>
        <CardTitle className="text-white flex items-center">
          <Upload className="h-5 w-5 mr-2 text-blue-400" />
          File Upload
        </CardTitle>
        <CardDescription className="text-gray-300">
          Upload X-rays, reports, or images (optional)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="border-2 border-dashed border-gray-600 rounded-lg p-6 text-center">
            <Upload className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-300 mb-2">
              Drag and drop files here, or click to select
            </p>
            <input
              type="file"
              multiple
              accept=".pdf,.jpg,.jpeg,.png,.dicom"
              onChange={handleFileChange}
              className="hidden"
              id="file-upload"
            />
            <label htmlFor="file-upload">
              <Button
                type="button"
                variant="outline"
                className="border-blue-400 text-blue-400 hover:bg-blue-400 hover:text-white"
              >
                Select Files
              </Button>
            </label>
            <p className="text-gray-500 text-sm mt-2">
              Supported formats: PDF, JPG, PNG, DICOM (Max 10MB each)
            </p>
          </div>

          {files.length > 0 &&
            <div className="space-y-2">
              <p className="text-white font-medium">Selected Files:</p>
              {files.map ((file, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-2 bg-gray-800 rounded"
                >
                  <span className="text-white text-sm">{file.name}</span>
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    onClick={() => removeFile (index)}
                    className="text-red-400 hover:text-red-300"
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>}
        </div>
      </CardContent>
    </Card>
  );
};

export default FileUploadSection;
